<div class="inidicator-value-filter-container">

    <button #select__toggle class="select__toggle" [ngClass]="{'select__toggle--rotated': showList}"
        (click)="toggleShowList()" (blur)="closeShowList()">
        <div class="select__toggle__icon"></div>
    </button>

    <!-- elementy -->
    <div class="filter-items-container" *ngIf="showList === true">

        <ul class="filter-items">
            <li class="filter-item" [ngClass]="{'selected' : currentValue===''}">
                <div (click)="onSelect('')">
                    <span class="filter-item-label">
                        {{'labels.all' | translate | titlecase}}
                    </span>
                </div>
            </li>

            <li *ngFor="let item of items" class="filter-item" [ngClass]="{'selected' : currentValue===item}">
                <div (click)="onSelect(item)">
                    <span class="filter-item-label" [title]="item">
                        {{item}}
                    </span>
                </div>
            </li>

        </ul>

    </div>

</div>
